import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTwitter, 
  FaTiktok, 
  FaYoutube, 
  FaLinkedinIn,
  FaTimes,
  FaArrowUp
} from 'react-icons/fa';
import '../../../assets/css/general/footer/Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Left Section - Logo & Description */}
        <div className="footer-left">
          <div className="footer-logo">
            <div className="logo-icon">
              <FaTimes className="logo-x" />
            </div>
            <h2 className="logo-text">studentSupportHub</h2>
          </div>
          
          <p className="footer-description">
            Helping underprivileged students continue their education by 
            connecting them with donors and trusted NGO partners through 
            a transparent and secure platform.
          </p>

          {/* Social Media Icons */}
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaTwitter />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaTiktok />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaYoutube />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Middle Section - Features */}
        <div className="footer-column">
          <h3 className="footer-column-title">FEATURES</h3>
          <ul className="footer-links">
           <li>
             <Link to="/student-support">
              Student Support Requests
            </Link>
          </li>
           <li>
             <Link to="/admin-verification">
               Admin Verification System
            </Link>
           </li>
            <li>
              <Link to="/donor-contribution">
                Donor Contribution Portal
              </Link>
            </li>
            <li>
              <Link to="/donation-tracking">
                Transparent Donation Tracking
              </Link>
            </li>
          </ul>
        </div>

        {/* Middle-Right Section - Resources */}
        <div className="footer-column">
          <h3 className="footer-column-title">RESOURCES</h3>
          <ul className="footer-links">
        <li>
    <Link to="/student-portal">
      Student Portal
    </Link>
  </li>
  <li>
    <Link to="/donor-portal">
      Donor Portal
    </Link>
  </li>
  <li>
    <Link to="/ngo-portal">
      NGO Portal
    </Link>
  </li>
  {/* <li>
    <Link to="/admin/dashboard">
      Admin Panel
    </Link>
  </li> */}
          </ul>
        </div>

        {/* Right Section - Stay in Touch */}
        <div className="footer-column footer-newsletter">
          <h3 className="footer-column-title">STAY IN TOUCH</h3>
          
          <div className="newsletter-form">
            {/* <input 
              type="email" 
              placeholder="Email" 
              className="newsletter-input"
            />
            <button className="newsletter-button">
              Subscribe
            </button> */}
          </div>

          <div className="footer-contact">
            <p className="contact-phone">+92-XXX-XXXXXXX</p>
            <p className="contact-email">support@studentsupporthub.com</p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button className="scroll-top-btn" onClick={scrollToTop}>
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;